// extracted by mini-css-extract-plugin
export default {"title":"Title_title__J8xZ4","container":"Title_container__3jGmQ"};